import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=0cfb372c&scoped=true"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=0cfb372c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb372c",
  null
  
)

export default component.exports